export const css = {
	oneaction: '_3OiHYtNw',
	primaryButton: '_3dPW4YTW',
	microQuizWrapper: 'uofCE5XN',
	microQuizHeader: '_3TYd1q2V',
	instructions: '_2SBapD85',
	passed_instructions: '_2a63Hmwl',
	score: 'pdA8MjGG',
	actions: '_2FmO4QTG',
	' _key': 'apic-theme/apic/micro/quiz-widgets/prometric'
};

export default css;
